/**
 * Used in Member-Login Page
 */
import React from 'react';
import Layout from '@/components/Layout';
import MemberLogin from '../../containers/MemberLogin';
import { fetchStoreInfo } from './../../services';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { fetchDomainFromHeaders } from '@/utils/fetchDomainFromHeaders';

const _MemberLogin = (props) => {
  return (
    <Layout
      store={props?.storeInfo}
      storeInfo={props?.storeInfo}
      title={props?.storeInfo.store_name}
      Icon={props?.storeInfo?.store_info?.logo_image}
      metaDescription={
        'Now order online from my whatsapp store & pay using 150+ UPI Apps'
      }
      OGImage={props?.storeInfo?.store_info?.logo_image}
      isCustomDomain={props.isCustomDomain}
    >
      <MemberLogin storeInfo={props.storeInfo} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  const userAgent = ctx?.req?.headers?.['user-agent'];
  if (checkForWrongDomain(ctx)) return {};

  const propData = {
    storeInfo: {},
    isCustomDomain: false,
  };

  const { isCustomDomain } = fetchDomainFromHeaders(ctx);
  propData.isCustomDomain = isCustomDomain;
  const storeResponse = await fetchStoreInfo({ ctx });

  if (storeResponse.data && storeResponse.data.status) {
    propData.storeInfo = JSON.parse(JSON.stringify(storeResponse.data.store));
  } else {
    ctx.res.writeHead(302, { location: '/404' });
    ctx.res.end();
    return { props: {} };
  }
  return { props: { ...propData, userAgent } };
}

export default _MemberLogin;
